const initialState = {
    pharmacyViewDetails:[],
    pharmacyPermissions:{},
    pharmacyLists: [],
    pharmacyHighlightedRecord: null,
    pharmacyListsId:[],
    pharmacyStatus: [],
    changedPharmacyStatus : [],
    loadingPharmacy: false,
    errorsPharmacy: {},
    pharmacyIds:"",
}

const  pharmacyReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_PHARMACYLIST_PENDING":
        case "ADD_PHARMACY_BASIC_PENDING":
        case "ADD_PHARMACY_DL_PENDING":
        case "ADD_PHARMACY_OWNER_PENDING":
        case "ADD_PHARMACIST_PENDING":
        case "ADD_GST_PAN_PENDING":
        case "ADD_LOCATED_HOSPITAL_PENDING":
        case "ADD_PHARMACY_AlERT_PENDING":
        case "ADD_BACK_LIST_PENDING":
        case "ADD_GRIEVANCE_PENDING":
        case "UPDATE_PHARMACY_PENDING":
        case "UPDATE_PHARMACY_STATUS_PENDING":
        case "UPDATE_PHARMACY_BASIC_PENDING":
        case "DELETE_PHARMACY_PENDING":
        case "GET_PHARMACYLISTBYID_PENDING":
        case "GET_PHARMACYVIEWLISTBYID_PENDING":
            return { ...state, loadingPharmacy: true , errorsPharmacy: {}  };

        case "GET_PHARMACYLIST_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                pharmacyLists: action.payload,
                pharmacyCount: action.count,
                pharmacyPermissions:action.permissions,
            };

        case "ADD_PHARMACY_BASIC_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                changedPharmacyStatus: action.payload,
                pharmacyIds:action.payload?.data?.id  || state.pharmacyIds,
                errorsPharmacy: {},
            };
        case "GET_PHARMACYVIEWLISTBYID_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                pharmacyViewDetails: action.payload,
            };
            case "UPDATE_PHARMACY_BASIC_FULFILLED":
                return {
                    ...state,
                    loadingPharmacy: false,
                    changedPharmacyStatus: action.payload,
                    pharmacyIds:action.payload?.data?.id  || state.pharmacyIds,
                    errorsPharmacy: {},
                };    

        case "ADD_PHARMACY_DL_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                changedPharmacyStatus: action.payload,
                pharmacyIds:action.payload?.data?.id  || state.pharmacyIds,
                errorsPharmacy: {},
            };

        case "ADD_PHARMACY_OWNER_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                changedPharmacyStatus: action.payload,
                pharmacyIds:action.payload?.data?.id  || state.pharmacyIds,
                errorsPharmacy: {},
            };

        case "ADD_PHARMACIST_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                changedPharmacyStatus: action.payload,
                pharmacyIds:action.payload?.data?.id  || state.pharmacyIds,
                errorsPharmacy: {},
            };

        case "ADD_GST_PAN_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                changedPharmacyStatus: action.payload,
                pharmacyIds:action.payload?.data?.id  || state.pharmacyIds,
                errorsPharmacy: {},
            };

        case "ADD_LOCATED_HOSPITAL_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                changedPharmacyStatus: action.payload,
                pharmacyIds:action.payload?.data?.id  || state.pharmacyIds,
                errorsPharmacy: {},
            };
            
            case "ADD_PHARMACY_AlERT_FULFILLED":
                console.log("action.payload",action.payload);
                return {
                    ...state,
                    loadingPharmacy: false,
                    changedPharmacyStatus: action.payload,
                    pharmacyIds:action.payload?.data?.id  || state.pharmacyIds,
                errorsPharmacy: {},
                };
            case "ADD_BACK_LIST_FULFILLED":
                return {
                    ...state,
                    loadingPharmacy: false,
                    changedPharmacyStatus: action.payload,
                    pharmacyIds:action.payload?.data?.id  || state.pharmacyIds,
                errorsPharmacy: {},
                };
            case "ADD_GRIEVANCE_FULFILLED":
                return {
                    ...state,
                    loadingPharmacy: false,
                    changedPharmacyStatus: action.payload,
                    pharmacyIds:action.payload?.data?.id  || state.pharmacyIds,
                errorsPharmacy: {},
                };
        case "UPDATE_PHARMACY_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                changedPharmacyStatus: action.payload,
                pharmacyIds:action.payload?.data?.id  || state.pharmacyIds,
                errorsPharmacy: {},
            };

        case "UPDATE_PHARMACY_STATUS_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                changedPharmacyStatus: action.payload,
            };

        case "GET_PHARMACYLISTBYID_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                pharmacyListsId: action.payload
            };

        case "DELETE_PHARMACY_FULFILLED":
            return {
                ...state,
                loadingPharmacy: false,
                changedPharmacyStatus: action.payload
            };

        case "RESET_DELETE_PHARMACYS_STATUS":
            return {
                ...state,
                loadingPharmacy: false,
                changedPharmacyStatus: [],
                errorsPharmacy:{},
                pharmacyListsId:[],
                pharmacyIds:"",
            };

        case "GET_PHARMACYLIST_REJECTED":
        case "ADD_PHARMACY_BASIC_REJECTED":
        case "ADD_PHARMACY_DL_REJECTED":
        case "ADD_PHARMACY_OWNER_REJECTED":
        case "ADD_PHARMACIST_REJECTED":
        case "ADD_GST_PAN_REJECTED":
        case "ADD_LOCATED_HOSPITAL_REJECTED":
        case "ADD_PHARMACY_AlERT_REJECTED":
        case "ADD_BACK_LIST_REJECTED":
        case "ADD_GRIEVANCE_REJECTED":
        case "UPDATE_PHARMACY_BASIC_REJECTED":
        case "UPDATE_PHARMACY_REJECTED":
        case "UPDATE_PHARMACY_STATUS_REJECTED":
        case "DELETE_PHARMACY_REJECTED":
        case "GET_PHARMACYLISTBYID_REJECTED":
        case "GET_PHARMACYVIEWLISTBYID_REJECTED":
            return {
                ...state,
                loadingPharmacy: false,
                errorsPharmacy: action.payload
            };
        case "SET_PHARMACY_HIGHLIGHTED_RECORD":
            return {
                ...state,
                pharmacyHighlightedRecord: action.payload,
            };
        case "CLEAR_PHARMACY_HIGHLIGHTED_RECORD":
            return {
                ...state,
                pharmacyHighlightedRecord: null,
            };

        default:
            return state;
    }
}

export default pharmacyReducer;